__turbopack_context__.v({
  "animateContent": "styles-module__yPYAvq__animateContent",
  "animatePopoverIn": "styles-module__yPYAvq__animatePopoverIn",
  "animatePopoverOut": "styles-module__yPYAvq__animatePopoverOut",
});
